import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import ReportOutstandingBalanceByAccountOfficer from "../reports/ReportOutstandingBalanceByAccountOfficer";


function OutstandingBalanceReportPerAccountOfficer() {
    return (
        <>
            <NavMain slug="outstanding-balance-report-per-account-officer" parent="3" />
            <HeaderMain slug="outstanding-balance-report-per-account-officer" />
            <div className="main-content">
                <ReportOutstandingBalanceByAccountOfficer />
            </div>
        </>
    );
}

export default OutstandingBalanceReportPerAccountOfficer;